import VoicePortal from "./VoicePortal";

const VoicePortalConfig = {
	settings: {},
	routes: [
		{
			path: '/voice-portal',
			component: VoicePortal
		}
	]
};

export default VoicePortalConfig;
